import { DEMO_LOCKED_FROM_STEP_LABEL } from "./demoConstants.js";

// 本登録案内モーダルの出し分け（reason は "save" / "locked" / "transfer"）。
// 保存できていない場合は reason より saveFailed を優先する。仕様は docs/demo.md 4.1〜4.3。
export const TITLE = {
  save: "入力内容を保存するには本登録が必要です",
  locked: `Step ${DEMO_LOCKED_FROM_STEP_LABEL} 以降は本登録が必要です`,
  saveFailed: "入力内容をこのブラウザに保存できていません",
};

// 見出しが上書きされたとき、本文の先頭へ回す reason。
// "transfer" は利用者が本登録を選んだ結果なので理由の説明は不要（docs/demo.md 4.1）
const LEAD_REASONS = ["save", "locked"];

export const buildDemoRegisterModalContent = ({ reason, saveFailed }) => ({
  title: saveFailed ? TITLE.saveFailed : (TITLE[reason] ?? TITLE.save),
  lead:
    saveFailed && LEAD_REASONS.includes(reason) ? `${TITLE[reason]}。` : null,
  confirmLabel: saveFailed
    ? "このまま本登録へ進む"
    : "本登録して内容を引き継ぐ",
  showTransferNotes: !saveFailed,
});
